// @ts-nocheck
export default ({ env }, inject) => {
  const {
    ZOHO_DESK_ASAP_APP_URL,
    ZOHO_DESK_ASAP_DEPARTMENT_ID,
    ZOHO_DESK_ASAP_LAYOUT_ID
  } = env
  if (!ZOHO_DESK_ASAP_APP_URL) return

  let isAsapReady = false
  let isAsapWidgetVisible = true
  let launcherEl = null
  let widgetRoot = null

  let email = ''
  let firstName = ''
  let lastName = ''
  let ipAddress = ''

  window.ZohoDeskAsapReady = cb => {
    // eslint-disable-next-line no-multi-assign
    const q = (window.ZohoDeskAsap__asyncalls =
      window.ZohoDeskAsap__asyncalls || [])
    if (window.ZohoDeskAsapReadyStatus) {
      if (cb) q.push(cb)
      q.forEach(fn => fn && fn())
      window.ZohoDeskAsap__asyncalls = null
    } else if (cb) {
      q.push(cb)
    }
  }

  /**
   * Random 16-byte nonce, Base64-encoded (same shape as Zoho's Java example).
   * Uses Math.random only — not the Web Crypto API or Node crypto module.
   */
  function generateZohoDeskAsapScriptNonce() {
    const bytes = new Uint8Array(16)
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
    let binary = ''
    for (let i = 0; i < bytes.length; i += 1) {
      binary += String.fromCharCode(bytes[i])
    }
    return btoa(binary)
  }

  function loadZohoAsap() {
    const d = document
    const s = d.createElement('script')
    s.type = 'text/javascript'
    s.id = 'zohodeskasapscript'
    s.defer = true
    s.nonce = generateZohoDeskAsapScriptNonce()
    s.src = ZOHO_DESK_ASAP_APP_URL

    const t = d.getElementsByTagName('script')[0]
    t.parentNode.insertBefore(s, t)

    document.body.removeEventListener('mouseenter', loadZohoAsap)

    window.ZohoDeskAsapReady(() => {
      isAsapReady = true

      const findElements = () => {
        if (!widgetRoot) {
          widgetRoot = document.querySelector(
            '[id*="zohodesk"], [class*="zohodesk"]'
          )
        }
        if (!launcherEl) {
          launcherEl = document.querySelector(
            'button[id*="zohodesk"], button[class*="zohodesk"], ' +
              '[id*="zohodesk"] button'
          )
        }
      }

      const mo = new MutationObserver(() => findElements())
      mo.observe(document.body, { childList: true, subtree: true })
      findElements()

      if (widgetRoot) widgetRoot.style.display = 'none'

      if (email || firstName || lastName || ipAddress) {
        window.ZohoDeskAsap.set('chat.gc.sessionVariables', [
          { name: 'email', value: email },
          { name: 'firstName', value: firstName },
          { name: 'lastName', value: lastName },
          { name: 'ipAddress', value: ipAddress }
        ])

        window.ZohoDeskAsap.set('ticket.form.prefillValues', {
          [`${ZOHO_DESK_ASAP_DEPARTMENT_ID}&&&${ZOHO_DESK_ASAP_LAYOUT_ID}`]: {
            contactId: {
              defaultValue: `${firstName} ${lastName}`
            }
          },
          email: {
            defaultValue: email
          }
        })
      }
    })
  }

  let _asapLoaded = false
  function ensureLoadOnce() {
    if (_asapLoaded) return
    _asapLoaded = true
    loadZohoAsap()
  }
  ensureLoadOnce()

  function showWidget() {
    if (widgetRoot) widgetRoot.style.display = ''
    if (typeof window.ZohoDeskAsap === 'function') {
      window.ZohoDeskAsap.invoke('show', 'app.launcher')
    }
  }
  function hideWidget() {
    if (widgetRoot) widgetRoot.style.display = 'none'
    if (typeof window.ZohoDeskAsap === 'function') {
      window.ZohoDeskAsap.invoke('hide', 'app.launcher')
    }
  }
  function openWidget() {
    try {
      if (typeof window.ZohoDeskAsap === 'function') {
        window.ZohoDeskAsap.invoke('open')
      }
    } catch {
      // Zoho ASAP not available
    }
    if (launcherEl) launcherEl.click()
  }
  function closeWidget() {
    try {
      if (typeof window.ZohoDeskAsap === 'function') {
        window.ZohoDeskAsap.invoke('close')
      }
    } catch {
      // Zoho ASAP not available
    }
  }

  const deskChat = {
    displayChatWidget: () => {
      if (isAsapReady) showWidget()
    },
    hideChatWidget: () => {
      if (isAsapReady) hideWidget()
    },
    openChatWindow: () => {
      if (isAsapReady) {
        showWidget()
        openWidget()
      }
    },
    minimizeChatWindow: () => {
      if (isAsapReady) {
        showWidget()
        closeWidget()
      }
    },
    toggleChatWindow: () => {
      if (isAsapReady) {
        if (isAsapWidgetVisible) {
          isAsapWidgetVisible = false
          hideWidget()
        } else {
          isAsapWidgetVisible = true
          showWidget()
        }
      }
    },
    setUser: user => {
      if (!user) return

      const name =
        user.name || [user.firstName, user.lastName].filter(Boolean).join(' ')
      window.ZohoHCAsapSettings = window.ZohoHCAsapSettings || {}
      const s = window.ZohoHCAsapSettings
      s.userInfo = {
        name: name || '',
        email: user.email || '',
        phone: user.phone || user.contact || ''
      }
      s.ticketsSettings = s.ticketsSettings || {}
      s.ticketsSettings.preFillFields = {
        email: { defaultValue: user.email || '' },
        name: { defaultValue: name || '' },
        phone: { defaultValue: user.phone || user.contact || '' }
      }

      email = user.email || ''
      firstName = user.firstName || ''
      lastName = user.lastName || ''
      ipAddress = user.ipAddress || ''

      if (isAsapReady) {
        window.ZohoDeskAsap.set('chat.gc.sessionVariables', [
          { name: 'email', value: email },
          { name: 'firstName', value: firstName },
          { name: 'lastName', value: lastName },
          { name: 'ipAddress', value: ipAddress }
        ])

        window.ZohoDeskAsap.set('ticket.form.prefillValues', {
          [`${ZOHO_DESK_ASAP_DEPARTMENT_ID}&&&${ZOHO_DESK_ASAP_LAYOUT_ID}`]: {
            contactId: {
              defaultValue: `${firstName} ${lastName}`
            },
            email: {
              defaultValue: email
            }
          }
        })
      }
    }
  }

  inject('deskChat', deskChat)
}
